import { createFileRoute } from "@tanstack/react-router";

import { OrganizationsList } from "@/features/wonda/components/OrganizationsList";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/organizations",
)({
  component: OrganizationsList,
});
